export { default as withDataHandler } from './withDataHandler';
export { default as withQueryParser } from './withQueryParser';
export { default as withTranslated } from './withTranslated';


// WEBPACK FOOTER //
// ./src/components/HOC/index.js